/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaintbrushThickRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACGElEQVR4nOWUu2sUURTGg4WNiIKKSEBTWAvBLoVdMGbmPEa4c04SXyB22gQbm4yPQDZ/RNInTdqAomAIBgQLwcbgozFJ4wMsxBeRMzt3szs7Ey9mOy9cWO7OfL9zvu/M7ev775dzbj+yzALJBrB8QNaGnfXMGGRtIOt2aTd6BgCSjS4A6WawANHYKJIs2I5ZLnRUj3iwovptsypIHFmzCoFsB5CeqwSQzoSI3696uVmhziPrDWRdL1ceFDKQ3K0Txy6/5TWRDA0PXzoQZIsXB5LfIQAguR4kXPL8J7CmQDodAJgLE8f0ShHQL0xSbevoQU+6MC+Lh69126b3qsVlC1mmmC8f+SsASL/YS0kycSIoeNJFoquHQ9wpOtDFYtTWnHOHKp9hmfLiWZbty8GJjgDLMrJ8AtKvyPqIKD0PrKtIstJ62SpH1rceAuBOA8tzJH3WAUk08iO527fid0eFoxfHT3mITVIBezHi3LEyLL9Cmpn9QJbJOB47GkWuH1jvNM8qAB4CrO88hEiGgOWlh7UyYX1YBD3Zdra6awd1EGxeD68A9HhLjPSjnVvlOznKSulKeVobOpEMtEMA9Ix148O1UO2/oBGtW3HsTiLJm462UQcLO56ULfqnFUWuH1mWgPQ7krxnHj+bd4CKPuSY5LbZZ8OQ/2b5DCw39wTOISyz9deH3tozwBawELA+zkeT5JtNl318/oE/tZ7Ez4SKY1IAAAAASUVORK5CYII=)
 */
export const PaintbrushThickRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.35 7.24C15.9 6.67 16 5.8 16 5a3 3 0 1 1 3 3c-.8 0-1.67.09-2.24.65a1.5 1.5 0 0 0 0 2.11l.4.4.26.24c.28.28.12.74-.26.85a7.01 7.01 0 0 0-4.03 2.94c-.19.29-.6.35-.83.1L6.9 9.92 4.3 12.54a1 1 0 0 0 0 1.42l2.17 2.17.83-.84a1 1 0 0 1 1.42 1.42l-.84.83.59.59 1.83-1.84a1 1 0 0 1 1.42 1.42l-1.84 1.83.17.17a1 1 0 0 0 1.42 0c.2-.2.56-.06.6.23.06.4.14.8.26 1.17.07.22 0 .46-.2.57a3 3 0 0 1-3.5-.55l-5.75-5.76a3 3 0 0 1 0-4.24L6.9 7.09h.01l.97-.97a3 3 0 0 1 4.24 0l1.12 1.12a1.5 1.5 0 0 0 2.1 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.24A3 3 0 0 0 19 16Z"
        className={colorClass}
      />
    </svg>
  );
};
